import Vue from "vue";
import VueI18n from "vue-i18n";
import ID from "view-design/dist/locale/id-ID";
import en from "view-design/dist/locale/en-US";
// import TH from "view-design/dist/locale/th-TH";
import zh from "view-design/dist/locale/zh-CN";
// import ES from "view-design/dist/locale/es-ES";
import cn from "../language/zh-CN";
// import th from "../language/cloud/th-TH";
import us from "../language/en-US";
import id from "../language/id-ID";
// import es from "../language/cloud/es-MX";
// import usLoc from "../language/icon+/en-US";
// import idLoc from "../language/icon+/id-ID";
const messages = {
  "zh-CN": Object.assign(zh, cn),
  // "th-TH": Object.assign(TH, th),
  "en-US": Object.assign(en, us),
  "id-ID": Object.assign(ID, id)
  // "es-MX": Object.assign(ES, es)
};
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "en-US",
  messages // set locale messages
});

export default i18n;
